export default __webpack_public_path__ + "static/media/mastercard.a735d1ea.png";